export default function Notifications() {
    return (
        <div className="flex flex-grow justify-center">
            <div className="h-1/2 flex items-center text-xl">
                <h1>Notifications</h1>
            </div>
        </div>
    );
}
